import React from 'react';

import GlobalShortcuts, { type GlobalShortcutsItem } from '@atlassian/global-shortcuts';
import { companyHub } from '@atlassian/global-shortcuts/company-hub';
import { jira } from '@atlassian/global-shortcuts/jira';
import { loom } from '@atlassian/global-shortcuts/loom';
import { teams } from '@atlassian/global-shortcuts/teams';

import { PEOPLE_DIRECTORY_SEARCH, COMPANY_HUB } from '@confluence/named-routes';
import { useSessionData } from '@confluence/session-data';

import { GlobalItemLoadables } from './GlobalItems/GlobalItemLoadables';

function companyHubComponent(): GlobalShortcutsItem {
	return {
		...companyHub(() => COMPANY_HUB.toUrl()),
		component: GlobalItemLoadables.companyHub,
	};
}

export const GlobalAppShortcuts = () => {
	const { cloudId, orgId } = useSessionData();

	return (
		<GlobalShortcuts
			testId="global-app-shortcuts"
			cloudId={cloudId}
			orgId={orgId}
			useSkeleton
			shortcutItems={[
				companyHubComponent(),
				jira(() => ''),
				loom(() => ''),
				teams(() => PEOPLE_DIRECTORY_SEARCH.toUrl()),
			]}
			promoteSite
			product="confluence"
		/>
	);
};
